const tableTransferFilter = (inputValue, item) => {
  const title = item.title.toLowerCase();
  const description = item.description.toLowerCase();
  const searchTerm = `${inputValue}`.toLowerCase();

  return title.indexOf(searchTerm) !== -1 || description.indexOf(searchTerm) !== -1;
};
export default tableTransferFilter;
